import React from 'react'
import PropTypes from 'prop-types'

const GuideMessage = ({ text, top }) => (
  <div className={`guide-message ${top ? '' : 'top-after-header'}`}>
    <p>
      {text}
    </p>
  </div>
)

GuideMessage.defaultProps = {
  top: false,
}

GuideMessage.propTypes = {
  text: PropTypes.string.isRequired,
  top: PropTypes.bool,
}

export default GuideMessage



// WEBPACK FOOTER //
// ./src/browser/components/GuideMessage.js